import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsentsRoutingModule } from './consents-routing.module';
import { ConsentRequestsComponent } from './consent-requests/consent-requests.component';
import { SharedModule } from '../components/shared.module';
import { DealSearchComponent } from './consent-requests/deal-search/deal-search.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AddRequestDialogComponent } from './consent-requests/add-request-dialog/add-request-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PersonSearchComponent } from './consent-requests/person-search/person-search.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConsentChecklistsComponent } from './consent-checklists/consent-checklists.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IndividualChecklistDialogComponent } from './consent-checklists/individual-checklist-dialog/individual-checklist-dialog.component';
import { TasksTableComponent } from './consent-checklists/individual-checklist-dialog/tasks-table/tasks-table.component';
import { EditDialogComponent } from './consent-checklists/individual-checklist-dialog/edit-dialog/edit-dialog.component';
import { PipesModule } from '../pipes/pipes.module';
import { ChecklistIndicatorComponent } from './consent-checklists/checklist-indicator/checklist-indicator.component';
import { ConsentApprovalsComponent } from './consent-approvals/consent-approvals.component';
import { IndividualApprovalsDialogComponent } from './consent-approvals/individual-approvals-dialog/individual-approvals-dialog.component';
import { ApprovalsTableComponent } from './consent-approvals/approvals-table/approvals-table.component';
import { ApprovalIndicatorComponent } from './consent-approvals/approval-indicator/approval-indicator.component';
import { InvestorApprovalsTableComponent } from './consent-approvals/investor-approvals-table/investor-approvals-table.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [
    ConsentRequestsComponent,
    DealSearchComponent,
    AddRequestDialogComponent,
    PersonSearchComponent,
    ConsentChecklistsComponent,
    IndividualChecklistDialogComponent,
    TasksTableComponent,
    EditDialogComponent,
    ChecklistIndicatorComponent,
    ConsentApprovalsComponent,
    IndividualApprovalsDialogComponent,
    ApprovalsTableComponent,
    ApprovalIndicatorComponent,
    InvestorApprovalsTableComponent,
  ],
  imports: [
    CommonModule,
    ConsentsRoutingModule,
    SharedModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTableModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSnackBarModule,
    PipesModule,
    FormsModule,
    MatButtonToggleModule,
  ],
})
export class ConsentsTrackingModule {}
